export const Strings = {
  OTP_VRIFICATION_DONE: "Otp Verification is successfully done",
  OTP_SENT: "OTP Sent",
  OTP_SENT_TO_NUMBER: "An OTP has been sent to your mobile number",
  ERROR_SENDING_OTP: "Error sending OTP",
  INVALID: "Invalid",
  PLEASE_ENTER_VALID_NUMBER: "Please enter valid email",
  SUCCESS: "Success",
  ERROR_OTP_VERIFICATION: "Error in otp code verification",
  ENTER_VALID_OTP: "Please enter valid OTP Code",
  NEW_OTP_SENT: "New OTP has been sent successfully",
  ERROR_SENDING_NEW_OTP: "Error sending new OTP",
  ENTER_EMAIL_NUMBER: "Please enter your email to receive a verification code.",
  EMAIL_ADDRESS: "Email Address",
  VERIFICATION: "Ultra AI Chat Verification",
  RESEND: "Resend",
  VERIFY: "Verify",
  DID_NOT_GET_CODE: "Didn't get a code?",
  LOGOUT: "Logout",
  LOGOUT_WARNING: "Are you sure want to Logout?",
  NOTIFICATION_PERMISSION: "Notification Permission",
  NOTIFICATION_PERMISSION_REQUIRED:
    "Notification Permission is required for using front desk",
  ACCEPT: "Accept",
  ENABLE_NOTIFICATION: "Enable Notification",
  IOS_PERMISSION:
    "You are using IOS Device.To enable notifications, Press share Button and click Add to Home Screen. Then open App from Home Screen",
  NOTIFICATION_PERMISSION_DENIED:
    "You have denied permission for notifications. Please enable it in your browser settings",

  //REVAMP
  LOGIN: "Login",
  WELCOME: "Welcome!",
  LOGIN_DESC:
    "I’m here to help you book courts, check coach info, see if courts are playable, and more – ",
  JUST_ASK: "just ask!",
  LOGIN_TC: "By logging in you indicate that you have read and agree to the ",
  TERMS_OF_SERVICE: "Terms of Service and Privacy Policy.",
  DONT_HAVE_ACCOUNT: "Don’t have account? ",
  SIGN_UP_HERE: "Sign up here",
  OTP_VERIFICATION: "OTP Verification",
  SEND_OTP: "Send the OTP via email",
  CODE_SENT_TO: "We've sent a code to",
  OTP_VERIFIED: "Your OTP Verification has been completed successfully!",
  RESEND_CODE: "Resend code again ",
  RESEND_AGAIN: "Resend again?",
  CHAT_ULTRA: "ChatUltra",
  WELCOME_DESC: "I'm here to help you with your Padel needs.",
  BOOK_A_COURT: "Book a Court",
  CANCEL_BOOKING: "Cancel a Booking",
  GET_COACH_INFO: "Get Info on Coaches",
  IF_COURTS_PLAYABLE: "Ask if Courts Are Playable",
  FIND_NEXT_AVAILABLE_COURT: "Find the Next Available Court",
  CHECK_IF_RAINING: "Check if It's Raining",
  THANK_YOU: "Thank you",
  ENTER_CODE: "Enter Code",
};
